import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 25rem;
  flex-shrink: 1;
`;

export const Search = styled.input`
  width: 100%;
  max-width: 20rem;
  padding: 0.5rem 0.75rem 0.5rem 2.5rem;
  height: 2.5rem;
  color: ${({ theme }) => theme.palette.neutral.lightest};
  border-radius: 1.5rem;
  border: 1px solid ${({ theme }) => theme.palette.neutral.medium};
  background-color: ${({ theme }) => theme.palette.neutral.darkest};
  box-sizing: border-box;
  font-size: 1rem;
  line-height: 1.5rem;
  transition: max-width 0.3s cubic-bezier(.4, 0, .2, 1), border-color 0.3s, box-shadow 0.3s;

  &:focus {
    max-width: 25rem;
    border-color: ${({ theme }) => theme.palette.primary.dark};
    outline: none;
    box-shadow: 0 0 2px ${({ theme }) => theme.palette.primary.light},
                0 0 2px ${({ theme }) => theme.palette.primary.light};
  }

  @media (max-width: 768px) {
    max-width: 100%;
    width: 100%;
  }
`;

export const SearchIcon = styled(FontAwesomeIcon)`
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: ${({ theme }) => theme.palette.neutral.medium};
  pointer-events: none;
`;

export const DropdownWrapper = styled.div`
  position: absolute;
  top: calc(100% + 0.5rem);
  left: 0;
  width: 100%;
  z-index: 60;
`;

export const DropdownList = styled.ul`
  margin: 0;
  padding: 0.25rem 0;
  list-style: none;
  background: ${({ theme }) =>
    theme.mode === "dark" ? "rgba(20, 20, 30, 0.95)" : "rgba(255, 255, 255, 0.95)"};
  backdrop-filter: blur(10px);
  border: 1px solid
    ${({ theme }) => (theme.mode === "dark" ? "rgba(255,255,255,0.15)" : "rgba(0,0,0,0.15)")};
  border-radius: 0.75rem;
  box-shadow: 0 8px 20px rgba(0,0,0,.35);
  max-height: 18rem;
  overflow-y: auto;
`;

export const DropdownItem = styled.li`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.6rem 0.9rem;
  cursor: pointer;
  transition: background 0.15s ease;
  color: ${({ theme }) => theme.palette.neutral.lightest};
  text-decoration: none;

  img {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    border-radius: 0.5rem;
    object-fit: cover;
    aspect-ratio: unset;
  }

  .info {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;

    .title {
      font-size: 0.95rem;
      font-weight: 500;
      color: ${({ theme }) => theme.palette.neutral.lightest};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .bottom {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      margin-top: 0.25rem;

      .price {
        font-size: 0.85rem;
        font-weight: 600;
        color: ${({ theme }) => theme.palette.success.light};
      }

      .stock-dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
      }

      .stock-qty {
        font-size: 0.75rem;
        color: ${({ theme }) => theme.palette.neutral.lightest};
      }
    }
  }

  &:hover {
    background: ${({ theme }) =>
    theme.mode === "dark" ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.06)"};
  }
`;
